import React from 'react'
import classNames from 'classnames'

import './InlineInput.scoped.sass'
import MailChip from '../WritingMessageModal/MessageModalContent/ToSection/components/MailChip'
import writingService from '@/app-domains/messages/draft/writing.service'

export function InlineInput (props) {
  const {
    label,
    autocorrect,
    autocomplete,
    spellcheck,
    autocapitalize,
    type = 'text',
    placeholder,
    inputName,
    value,
    disabled,
    required,
    maxLength,
    showError = true,
    errorMessage = '',
    infoMessage = '',
    onInput,
    onKeyDown,
    size = '',
    fullWidth,
    onBlur,
    recipientType,
  } = props

  // eslint-disable-next-line
  const isEmpty = !value
  const _showError = () => {
    return errorMessage && showError
  }
  
  // eslint-disable-next-line
  const _showInfo = () => {
    return !_showError() && infoMessage
  }
  const _onBlur = (e) => { onBlur && onBlur(e) }
  const _onFocus = (e) => { e.preventDefault() }
  const _onInput = (e) => {
    if (onInput) onInput(e)
  }

  function getMailChips () {
    return props.draft && props.draft[recipientType]?.map((mail) => {
      return <MailChip
          key={mail}
          mail={mail}
          onDeleteHandler={() => {
            if (recipientType === 'tos') return writingService.removeToAddress(mail)
            if (recipientType === 'ccs') return writingService.removeCCAddress(mail)
            if (recipientType === 'bccs') return writingService.removeBCCAddress(mail)
          }}
        />
    })
  }

  return <div className={classNames(`input ${size}`, {
    '_is-invalid': _showError(),
    '_is-disabled': disabled,
    '_is-required': required,
    '_full-width': fullWidth
    // '_show-error': show_error,
  })} >
    {getMailChips()}
    <input
      required={required}
      disabled={disabled || null}
      name={inputName}
      type={type}
      value={value}
      placeholder={placeholder}
      autoComplete={autocomplete === true ? 'on' : (autocomplete || 'nope')}
      autoCorrect={autocorrect ? 'on' : 'off'}
      autoCapitalize={autocapitalize === true ? 'on' : (autocapitalize || 'off')}
      spellCheck={spellcheck}
      maxLength={maxLength || null}
      aria-label={label}
      onBlur={_onBlur}
      onFocus={_onFocus}
      onChange={_onInput}
      onKeyDown={onKeyDown}
    />

  </div>
}
